import * as React from 'react';

import { HardcodedToDoExplainer } from 'kb-shared';

import IDUploadButton from '../../PhotoUpload/ID/IDUploadButton';
import ButtonTodo from './ButtonTodo';

interface Props {
  explainer: HardcodedToDoExplainer;
}

const UploadID = (props: Props) => {
  const {
    explainer: { title, body }
  } = props;
  return <ButtonTodo title={title} copy={body} ButtonComponent={<IDUploadButton />} />;
};

export default UploadID;
